import React from "react";
import "../App.css";

const NotFoundPage = () => (
  <div className="page-container">
    <h1>404 - Page Not Found</h1>
    <p>Oops! The page you are looking for does not exist.</p>
  </div>
);

export default NotFoundPage;
